module.exports = __webpack_public_path__ + "img/signin_bg.08e0f4b2.png";